"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var axios_1 = require("axios");
var constants_1 = require("../constants/constants");
var CatalogService = /** @class */ (function () {
    function CatalogService(config) {
        if (config === void 0) { config = {}; }
        var getHeaders = config.getHeaders, axiosConfig = tslib_1.__rest(config, ["getHeaders"]);
        this.axiosInstance = axios_1.default.create(tslib_1.__assign({ baseURL: constants_1.CATALOG_URL, withCredentials: true, xsrfCookieName: undefined, xsrfHeaderName: undefined }, axiosConfig));
        this.axiosInstance.interceptors.request.use(function (req) {
            var headers = req.headers;
            if (getHeaders) {
                headers = tslib_1.__assign({}, req.headers, getHeaders());
            }
            return tslib_1.__assign({}, req, { headers: headers });
        });
    }
    CatalogService.prototype.getAxiosInstance = function () {
        return this.axiosInstance;
    };
    return CatalogService;
}());
exports.CatalogService = CatalogService;
//# sourceMappingURL=catalog-service.js.map